module.exports = __webpack_public_path__ + "static/media/p1.74c07c51.jpg";